<div class="contact-composition" [class.hub-composition]="insideModal() && selectedTab === 'hub'">
  <!-- New Contact (a create modal): no avatar tile and the modals' title row (`skin-detail-heading`), so the title sits
       as close to the tabs as in every other create modal, as the prototype's create modal has it (Johanna, 2026-10-21). -->
  <div
    class="heading"
    [class.full-header]="!dp"
    [class.skin-detail-heading]="creatingInModal()"
    (resize)="handleResize($event)"
  >
    @if (canGoBack()) {
      <app-button2 appearance="secondary-ghost" size="s" aria-label="Go back" (click)="handleGoBack()">
        <app-icon name="chevron-left" />
      </app-button2>
    }

  <!-- New Contact keeps its empty avatar too (Johanna, 2026-10-21, reversing issue 31). -->
  <div class="logo">
    {{ form.controls.title.value | initials: 3 }}
  </div>

    <app-input
      class="input"
      appearance="sapphire-inline"
      [inputFormControl]="form.controls.title"
      placeholder="New Contact"
      [errorPlaceholder]="'Add title'"
      [withErrors]="submitted"
      size="s"
      [customStyles]="contracted ? { 'text-overflow': 'ellipsis' } : undefined"
      [attr.title]="contracted ? form.controls.title.value : null"
    />

    @if (!dp) {
      <div class="identity-details">
        @if (form.controls.emails.value[0]?.value; as email) {
          <div [title]="email"><strong>Email:</strong> {{ email }}</div>
        }
        @if (form.controls.phones.value[0]?.value; as phone) {
          <div [title]="phone"><strong>Phone:</strong> {{ phone }}</div>
        }
      </div>
    }

    <!-- stitch-app-shell FolderBadge: the contact's group hung 2px under the header icons. -->
    @if (!dp && headerGroup()) {
      <div class="header-badge">
        <ng-container [ngTemplateOutlet]="groupBadge" />
      </div>
    }

    <div class="icons">
      <div [appPreventDirtyClick]="dirtyFormRef" class="contents">
        <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
        <stch-quick-action
          *ngIf="!contracted"
          appearance="sapphire-toggle"
          size="m"
          icon="bug"
          [active]="selectedTab === 'debug'"
          matTooltip="Debug"
          (onClick)="selectedTab = 'debug'"
        />
        -->

        <stch-quick-action
          *ngIf="!contracted"
          appearance="sapphire-toggle"
          size="m"
          icon="sapphire-archive2"
          [active]="form.controls.archived.value"
          [matTooltip]="form.controls.archived.value ? Labels.RestoreFromArchive : Labels.Archive"
          [disabled]="!contact?.id"
          (onClick)="archive()"
        />

        <stch-trash-action
          *ngIf="!contracted"
          [deleted]="form.controls.deleted.value"
          [disabled]="!contact?.id"
          (onClick)="delete()"
        />

        <ng-container
          *ngComponentOutlet="workspaceComponents['app-item-workspace-chip']; inputs: workspaceChipInputs"
        />
        <stch-quick-action
          *ngIf="!contracted"
          appearance="sapphire-toggle"
          size="m"
          icon="sapphire-share"
          matTooltip="Share"
          [disabled]="!contact?.id"
          [stchShareContextMenu]="contact"
          [stchShareContextMenuDisabled]="!contact?.id"
        />

        <app-button
          appearance="sapphire-secondary-ghost"
          size="xs"
          icon="sapphire-ellipsis"
          matTooltip="More options"
          ariaLabel="More options"
          [disabled]="!contact?.id"
          (appContactContextMenu2Tab)="
            $event === 'access'
              ? openWorkspaceAccess()
              : $event === 'versions'
                ? openVersionHistory()
                : openItemComments()
          "
          [appContactContextMenu2ElementLocation]="UILocations.mainView"
          [appContactContextMenu2]="contact"
          appContactContextMenu2Mode="popover"
          [appContactContextMenu2Disabled]="!contact?.id"
          [printEnabled]="true"
        />
      </div>

      @if (showCloseButton) {
        <app-button appearance="sapphire-secondary-ghost" size="xs" icon="sapphire-close" (click)="handleClose()" />
      }
    </div>
  </div>

  <!-- In a narrow panel the badge takes a row of its own under the header. -->
  @if (dp && headerGroup()) {
    <div class="flex justify-end pr-8">
      <ng-container [ngTemplateOutlet]="groupBadge" />
    </div>
  }

  @if (!contact?.id && workspaceIdentity(); as identity) {
    <app-tenancy-selector
      [spaceTitle]="identity.spaceTitle"
      [spaceTenantId]="identity.spaceTenantId"
      [memberTenantId]="identity.memberTenantId"
      itemNoun="contact"
      [locked]="saveInProgress || draftOwnerLocked || form.controls.uploads.value.length > 0"
      [lockedReason]="draftOwnerLocked ? 'This draft already belongs to a workspace.' : null"
      [tenantId]="sharingTenantId()"
      (tenantIdChange)="setSharingTenantId($event)"
    />
  }

  <div class="tabs">
    <app-tabs appearance="sapphire" [values]="workspaceTabs" [(value)]="selectedTab" size="m" />

    <div class="filler"></div>

    @if (handoverTenantId) {
      <app-button2
        appearance="secondary"
        size="m"
        [height]="32"
        rounding="lg"
        data-handover-anchor
        [ariaLabel]="handoverControl.accessibleName()"
        [ariaHaspopup]="'dialog'"
        [disabled]="!handoverCanAssign || handoverControl.busy()"
        [attr.title]="handoverCanAssign ? null : 'Requires edit access'"
        [ariaDescribedBy]="
          !handoverCanAssign
            ? handoverControl.ids.title + '-edit'
            : handoverControl.busy()
              ? handoverControl.ids.busy
              : null
        "
        (click)="handoverCanAssign && handoverControl.openAssign()"
      >
        <app-icon name="sapphire-user-plus" size="m" />
        {{ handoverControl.buttonLabel() }}
        <app-icon name="sapphire-chevron-down" size="s" />
        <span class="sr-only" [id]="handoverControl.ids.title + '-edit'">{{
          handoverCanAssign ? '' : 'Requires edit access'
        }}</span>
      </app-button2>
    }
    <stch-knowledge-button [active]="displayKnowledge" (click)="showKnowledge()" />
  </div>
  <app-item-handover
    #handoverControl
    [api]="handoverApi"
    [enabled]="!!handoverTenantId"
    [showButton]="false"
    [itemId]="handoverItemId"
    [tenantId]="handoverTenantId"
    [insideModal]="insideModal()"
    [matchItemSignals]="true"
    [stitchType]="StitchType.CONTACT"
    [prototypeWindow]="true"
    noun="contact"
  />
  <app-item-review
    [api]="reviewApi"
    [enabled]="!!handoverTenantId"
    [itemId]="handoverItemId"
    [tenantId]="handoverTenantId"
    [insideModal]="insideModal()"
    [stitchType]="StitchType.CONTACT"
    [contentVersion]="reviewContentVersion()"
  />

  <div
    class="form"
    [class.contact-dirty]="!pristine"
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppableDisabled]="!stitchItem?.id"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event)"
  >
    <div class="drop-area-border"></div>

    @if (selectedTab === 'hub' && hasKnowledgeHubAccess()) {
      <app-entity-hub-search [contactId]="contact?.id" />
    }

    @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
      <app-entity-hub-search [contactId]="contact?.id" />
    }

    <div class="form-heading">
      <div class="form-heading-nav">
        <div class="form-heading-nav-separator"></div>

      </div>

      <div *ngIf="displayKnowledge" class="form-heading-nav-underline"></div>

      <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections. -->
      <div class="form-knowledge" [class.hidden]="!displayKnowledge || ((selectedTab === 'hub' || selectedTab === 'stitch') && !hasKnowledgeHubAccess())">
        <app-knots
          class="form-knots"
          [class.hidden]="!displayKnowledge || ((selectedTab === 'hub' || selectedTab === 'stitch') && !hasKnowledgeHubAccess())"
          [stitchItems]="contact | toArray"
          [control]="form.controls.knots"
          [stateKey]="StateKey.knotsList"
          [withControls]="selectedTab !== 'hub' && selectedTab !== 'stitch'"
          [isHubMode]="(selectedTab === 'hub' || selectedTab === 'stitch') && hasKnowledgeHubAccess()"
          [hubEntityUid]="selectedTab === 'hub' && !contact.emails?.[0]?.value ? undefined : contact.id"
          [hubName]="selectedTab === 'hub' ? contact.emails?.[0]?.value : undefined"
        />

        <app-tags
          class="form-tags"
          [class.hidden]="!displayKnowledge || ((selectedTab === 'hub' || selectedTab === 'stitch') && !hasKnowledgeHubAccess())"
          [stitchItems]="[contact]"
          [control]="form.controls.tags"
          [stateKey]="StateKey.tagsList"
          [withControls]="selectedTab !== 'hub' && selectedTab !== 'stitch'"
          [isHubMode]="(selectedTab === 'hub' || selectedTab === 'stitch') && hasKnowledgeHubAccess()"
          [hubEntityUid]="selectedTab === 'hub' && !contact.emails?.[0]?.value ? undefined : contact.id"
          [hubName]="selectedTab === 'hub' ? contact.emails?.[0]?.value : undefined"
        />

        <app-connections
          class="form-knots"
          [class.hidden]="!displayKnowledge || ((selectedTab === 'hub' || selectedTab === 'stitch') && !hasKnowledgeHubAccess())"
          [stitchItems]="[contact]"
          [control]="form.controls.connections"
          [stateKey]="StateKey.connectionsList"
          [withControls]="selectedTab !== 'hub' && selectedTab !== 'stitch'"
          [isHubMode]="(selectedTab === 'hub' || selectedTab === 'stitch') && hasKnowledgeHubAccess()"
          [hubEntityUid]="selectedTab === 'hub' && !contact.emails?.[0]?.value ? undefined : contact.id"
          [hubName]="selectedTab === 'hub' ? contact.emails?.[0]?.value : undefined"
          [hubExcludedEmails]="selectedTab === 'stitch' ? contact.emails : undefined"
        />
      </div>
    </div>

    <app-scroll
      *ngIf="selectedTab !== 'hub' && (selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))"
      [ngSwitch]="selectedTab"
      class="form-scroll"
      (top)="displayScrollShadow = !$event"
    >
      <div *ngIf="displayScrollShadow" class="form-scroll-shadow"></div>

      <div *ngSwitchCase="'contact'" class="form-kit" [class.contracted]="contracted">
        <section class="form-kit-section">
          <!-- Her order (2026-10-21): Phone, Email, VIP, Job title · Company, Website, Address, Country, Birthday, Group. -->
          <div class="form-kit-field">
            <span class="form-kit-label">Phone Number</span>
            <app-controls-list
              [items]="form.controls.phones"
              [itemTemplateRef]="phoneNumberItemTemplate"
              (onAddItem)="handleAddItem('phones', $event)"
            >
              <ng-template #phoneNumberItemTemplate let-phoneNumberControl="item">
                <app-input-side-options
                  [sideFormControl]="phoneNumberControl.controls.category"
                  [sideOptions]="contactInfoTypes"
                >
                  <app-input
                    class="w-full"
                    [inputFormControl]="phoneNumberControl.controls.value"
                    [customStyles]="{ border: 'none' }"
                    type="tel"
                    placeholder="Phone Number"
                  />
                </app-input-side-options>
              </ng-template>
            </app-controls-list>
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Email</span>
            <app-controls-list
              [items]="form.controls.emails"
              [itemTemplateRef]="emailItemTemplate"
              (onAddItem)="handleAddItem('emails', $event)"
            >
              <ng-template #emailItemTemplate let-emailControl="item">
                <app-input-side-options [sideFormControl]="emailControl.controls.category" [sideOptions]="contactInfoTypes">
                  <app-input
                    [inputFormControl]="emailControl.controls.value"
                    [customStyles]="{ border: 'none' }"
                    placeholder="Enter email"
                  />
                </app-input-side-options>
              </ng-template>
            </app-controls-list>
          </div>

          <div class="form-kit-inline">
            <app-checkbox2 [formControl]="form.controls.vip" label="VIP Contact" size="s" />
          </div>

          <!-- Job title and Company side by side (Johanna, 2026-10-21). -->
          <div class="form-kit-row">
            <div class="form-kit-field">
              <span class="form-kit-label">Job Title</span>
              <app-input
                appearance="sapphire-outline"
                [inputFormControl]="form.controls.jobTitle"
                placeholder="Job Title"
                [withErrors]="submitted"
                [withClear]="true"
                size="s"
              />
            </div>
            <div class="form-kit-field">
              <span class="form-kit-label">Company</span>
              <app-input
                appearance="sapphire-outline"
                [inputFormControl]="form.controls.company"
                placeholder="Company"
                [withErrors]="submitted"
                [withClear]="true"
                size="s"
              />
            </div>
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Website</span>
            <app-input
              appearance="sapphire-outline"
              [inputFormControl]="form.controls.website"
              placeholder="Website"
              [withErrors]="submitted"
              [validationMessages]="websiteValidationMessages"
              [withClear]="true"
              size="s"
            />
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Address</span>
            <app-input
              appearance="sapphire-outline"
              [inputFormControl]="form.controls.address"
              placeholder="Address"
              [withErrors]="submitted"
              [withClear]="true"
              size="s"
            />
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Country</span>
            <app-input
              [inputFormControl]="form.controls.country"
              [withClear]="true"
              placeholder="Enter country"
            />
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Birthday</span>
            <app-dropdown-date-input
              [control]="form.controls.birthDate"
              [withClear]="true"
              appearance="sapphire-outline"
              placeholder="Birthday"
              size="m"
            />
          </div>

          <div class="form-kit-field">
            <span class="form-kit-label">Group</span>

            <app-autocomplete-input
              appearance="sapphire-outline"
              placeholder="Add To Group"
              [suggestions]="suggestions"
              [inputFormControl]="form.controls.groupId"
              size="s"
              [withErrors]="submitted"
              [withClear]="true"
            />
          </div>
        </section>

        <section class="form-kit-section">
          <stch-item-description-field
            [control]="form.controls.description"
            [item]="contact"
            [tagsControl]="form.controls['tags']"
            [knotsControl]="form.controls['knots']"
          />
        </section>

        <!-- Team workspace handover (main): who answers for the contact and who made it, as a read-only InfoList. -->
        @if (handoverTenantId) {
          <section class="form-kit-section">
            <dl class="form-kit-info">
              <div class="form-kit-info-row">
                <dt>Responsible</dt>
                <dd data-testid="details-responsible">{{ handoverControl.responsibleName() }}</dd>
              </div>
              @if (handoverControl.creatorName(); as author) {
                <div class="form-kit-info-row">
                  <dt>Created by</dt>
                  <dd data-testid="details-authored-by">{{ author }}</dd>
                </div>
              }
            </dl>
          </section>
        }
      </div>

      <app-attachments-list
        class="form-attachments"
        *ngSwitchCase="'attachments'"
        [stitchItem]="stitchItem"
        [inputControl]="form.controls.uploads"
        [tenantItems]="tenantCarrier()"
        [contextMenuStateVariant]="attachmentsMenuStateVariant"
        (listStateChange)="attachmentsListState = $event"
        (onClickItem)="handleClickItem($event)"
        (onDblClickItem)="handleDblClickItem($event)"
        (uploading)="onUploadingChange($event)"
      />

      <app-context-menu-state-indicator
        *ngSwitchCase="'stitch'"
        class="block ml-auto w-fit mt-5 mr-4"
        svgIcon="filters"
        appStitchListContextMenu
        (appStitchListContextMenuChange)="stitchListState = $event"
      />

      <app-linked-info-list
        *ngSwitchCase="'stitch'"
        class="form-linked-info"
        [stitch]="contact"
        [state]="stitchListState"
        (clickStitchItem)="handleClickItem($event)"
        (dblClickStitchItem)="handleDblClickItem($event)"
      />

      <div *ngSwitchCase="'access'" class="form-linked-info">
        <ng-container
          *ngComponentOutlet="workspaceComponents['app-item-workspace-access']; inputs: workspaceAccessInputs"
        />
      </div>

      <stch-comments
        (countChanged)="commentsCount.set($event)"
        [insideTeam]="insideTeam"
        *ngSwitchCase="'comments'"
        class="form-linked-info"
        [stitch]="contact"
      />

      <ng-container *ngSwitchCase="'activity'">
        @if (itemChangesInputs; as inputs) {
          <ng-container *ngComponentOutlet="workspaceComponents['app-item-changes']; inputs: inputs" />
        }
      </ng-container>

      <ng-container *ngSwitchCase="'versions'">
        @if (historyAvailable()) {
          <ng-container
            *ngComponentOutlet="workspaceComponents['app-contact-version-history']; inputs: versionHistoryInputs"
          />
        }
      </ng-container>

      <stch-json-viewer *ngSwitchCase="'debug'" [json]="contact?.debug" />
    </app-scroll>

    @if (selectedTab === 'hub') {
      @if (!permissionsLoaded()) {
        <!-- Render nothing until permission rules arrive to avoid flashing the wrong pane -->
      } @else if (hasKnowledgeHubAccess()) {
        <app-entity-hub [contact]="stitchItem" />
      } @else {
        <app-feature-upsell
          class="flex-1"
          title="Knowledge Hub"
          description="AI-powered summaries, entities, themes, and key terms for your items. Upgrade your plan to unlock Knowledge Hub."
          imageSrc="assets/placeholders/placeholder-files.svg"
        />
      }
    }

    @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
      <app-stitch-hub
        [stitch]="contact"
        (clickStitchItem)="handleClickItem($event)"
        (dblClickStitchItem)="handleDblClickItem($event)"
      />
    }

    <stch-save-cancel-panel
      [enabled]="!pristine"
      [uploading]="isUploading()"
      (onCancel)="handleCancel()"
      (onSave)="handleSubmit()"
    />

  </div>

  <ng-container *ngComponentOutlet="workspaceComponents['app-item-quick-comment']; inputs: quickCommentInputs" />

  <!-- stitch-app-shell breadcrumbs footer in the main view, as in every app; elsewhere the workspace footer. -->
  @if (navigation.enabled && contact?.id) {
    <app-detail-breadcrumbs
      [crumbs]="breadcrumbs()"
      [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
    />
  } @else {
    <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-footer']; inputs: workspaceFooterInputs" />
  }
</div>

<!-- The contact's group in its colour. -->
<ng-template #groupBadge>
  @if (headerGroup(); as group) {
    <app-container-badge type="group" class="min-w-0" [title]="group.title" [color]="group.color" />
  }
</ng-template>
